import api from './Axios';

/**
 * Legacy Credits API
 * Base: /api/legacyCredits
 */

export const addLegacyCredit = (data) =>
  api.post('/legacyCredits', data);

export const getMonthlyLegacyCredits = (month, year) =>
  api.get(`/legacyCredits/monthly?month=${month}&year=${year}`);

export const getLegacyCreditsByUser = (userId) =>
  api.get(`/legacyCredits/user/${userId}`);

export const verifyLegacyCredit = (creditId, data) =>
  api.put(`/legacyCredits/${creditId}/verify`, data);

export const getSpecificUserThisMonthLegacyCredit = (userId) =>
  api.get(`/legacyCredits/user/${userId}/current`);